import { BoxRadius, Color } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Menu } from 'native-base';
import React from 'react';

import { SinacorAccount } from '../../../store/customer/types';

import { AccountRow } from './AccountRow';

const menuItemStyle = {
  width: '100%' as const,
  borderRadius: Utils.Token.ToInt(BoxRadius, 'sm'),
  overflow: 'hidden' as const,
  paddingHorizontal: 0,
};

const menuItemBackgroundColor = {
  backgroundColor: Color['brand.tertiary.lightest'],
  ...menuItemStyle,
};

interface AccountMenuItemProps {
  account: SinacorAccount;
  isSelected: boolean;
  onSelect: (sinacorAccount: string) => void;
}

export const AccountMenuItem: React.FC<AccountMenuItemProps> = ({
  account,
  isSelected,
  onSelect,
}) => {
  return (
    <Menu.Item
      onPress={() => onSelect(account.sinacorAccountNormalized)}
      _focus={menuItemBackgroundColor}
      _hover={menuItemBackgroundColor}
      style={menuItemStyle}>
      <AccountRow
        custodyAccountNormalized={account.custodyAccountNormalized}
        sinacorAccountNormalized={account.sinacorAccountNormalized}
        isSelected={isSelected}
      />
    </Menu.Item>
  );
};
